import getV10APIs from './v1.0';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);

  const children = [
    mergeVersionsByTitle('정산내역 조회', v10APIs),
    mergeVersionsByTitle('주문관리 정산 조회', v10APIs),
    mergeVersionsByTitle('SKU별 추정 매출현황 조회', v10APIs),
  ].filter(Boolean);

  return { title: '정산', children };
};

export default data;
